// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__34Vns","mobileMenu":"Accordion_mobileMenu__mHhgO"};